export default "__VITE_ASSET__90114559__"